module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy1"
  }, [_vm._v("Copyright © 2018 Jill Caroff Baker")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("All rights reserved. Except as permitted under the U.S. Copyright Act of 1976, no part of this publication may be reproduced, distributed, or transmitted in any form or by any means, or stored in a database or retrieval system, without the prior written permission of the publisher. For permission, please contact "), _c('a', {
    attrs: {
      "href": "http://www.sudburypublishinggroup.com/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Sudbury Publishing Group")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Published worldwide by Sudbury Publishing Group.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("This book is a work of fiction. All characters, organizations, locations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Editor, Interior Design, and Production: Jonathan W. Baker"), _c('br'), _vm._v("Cover Design: Jill C. Baker")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN 978-1-949283-00-6 (paperback)"), _c('br'), _vm._v("ISBN 978-1-949283-01-3 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("10 9 8 7 6 5 4 3 2")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("First Edition")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b7b0eed","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/copyright.vue
// module id = 60
// module chunks = 0